/**************************************************
 * Nombre:       Seccion_Prueba
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {AddBoxOutlined, BalanceOutlined, ManageSearch} from '@mui/icons-material'
import {useObtenerColleccionTabla2025} from "../../Servicios/BD/useObtenerColleccionTabla2025";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Tabla_Filtro from "../../Modulo_Tabla_2025/Componentes/Tabla_Filtro";
import {
    CASILLA_ESTADO,
    CASILLA_FECHA_DATOS,
    CASILLA_MONEDA,
    CASILLA_PARRAFO
} from "../../Modulo_Tabla_2025/Componentes/SubComponentes/obtenerCasilla";
import React, {useContext} from "react";
import {usuarioContext} from "../../App";
import {ESTADOANUNCIOS} from "../../Constantes";
import Dialogo_Pagos from "../Dialogos/Dialogo_Pagos";
import Dialogo_Pedido_Pago from "../Dialogos/Dialogo_Pedido_Pago";


const Seccion_Pagos = () => {
    const usuario = useContext(usuarioContext).usuario
    const {
        props,
        cargarNuevamente,
        numeroFilas
    } = useObtenerColleccionTabla2025({coleccion: 'pagos'})
    const {Dialogo, abrir} = useDialogo({
        Componente: Dialogo_Pagos,
        titulo: 'Detalles del cobro',
        realizado: cargarNuevamente
    })
    const {Dialogo: DialogoPago, abrir: abrirPago} = useDialogo({
        Componente: Dialogo_Pedido_Pago,
        titulo: 'Detalles del cobro',
        realizado: cargarNuevamente
    })


    const click = (id, data) => {
        // console.log(data)
        switch (id) {
            case 'detalles':
                abrir(data)
                break
            case 'pago':
                abrirPago(data)
                break

        }
    }


    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>


            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{marginTop: 2.5, maxWidth: '1400px'}}
                spacing={3}
            >

                <Dialogo/>

                <DialogoPago/>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Tabla_Filtro
                        nombre={'Cobros'}
                        descripcion={`${numeroFilas} cobros en base de datos`}
                        filtros={filtros}
                        datosCabecera={datosCabecera}
                        {...props}
                        clickAgregar={abrir}
                        botonesData={botonesData}
                        clickData={click}
                        // funcionBuscar={funcionBuscar}
                        //ComponenteInferior={ExportadorDatos}

                    />
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Seccion_Pagos

const filtros = [
    {
        nombre: 'Nombre',
        direccion: 'asc',
        propiedad: 'nombre'
    },
    {
        nombre: 'Mas Reciente',
        direccion: 'desc',
        propiedad: 'fecha'
    }
]


const datosCabecera = [

    {
        nombre: 'Nombre',
        direccion: 'left',
        propiedades: ['consecutivo', 'nombre'],
        fecha: 'fecha',
        tipo: CASILLA_FECHA_DATOS

    },
    {
        nombre: 'descripcion',
        direccion: 'left',
        propiedad: 'descripcion',
        lineas: 2,
        tipo: CASILLA_PARRAFO
    },

    {
        nombre: 'Valor',
        direccion: 'left',
        propiedad: 'valor',
        tipo: CASILLA_MONEDA
    },
    {
        nombre: 'Estado',
        direccion: 'right',
        propiedad: 'estado',
        tipo: CASILLA_ESTADO,
        estados: ESTADOANUNCIOS
    }


]


const botonesData = [
    {
        nombre: 'Detalles',
        id: 'detalles',
        icono: ManageSearch
    },
    {
        nombre: 'Pago',
        id: 'pago',
        icono: BalanceOutlined
    }
]


